import { render, staticRenderFns } from "./OfficeImporterView.vue?vue&type=template&id=5d676d70&"
import script from "./OfficeImporterView.vue?vue&type=script&lang=js&"
export * from "./OfficeImporterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports